import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import BlogsData from '../Blogs/BlogsData';
import InnerPageBanner from '../Banner/InnerPageBanner';
import BannerBG from "../../assests/img/creattive-dots-banner.jpeg";
import Logo from "../../assests/img/Creative-Dots-logo.png";

const SingleBlogPage = () => {
    const params = useParams();
    const [blog, setBlog] = useState({});

    useEffect(()=>{
      if(params) {
        const BlogObj = BlogsData?.find((blog) => blog?.Title === params?.title);
        setBlog(BlogObj)
      }
    },[params])

    const navigate = useNavigate();

    const handleBlogView = (title) => {
      navigate(`/blog/${title}`)
    }

  return (
    <>
      <InnerPageBanner BannerBG={BannerBG} Title={blog?.Title} />
      <section className='gravity-container py-16 px-4 sm:px-2 md:px-0 flex flex-col sm:flex-row gap-[40px]'>
        <div className='w-[65%] flex flex-col gap-6 items-center'>
          <div className='flex justify-center items-center w-[150px] h-[50px] bg-[#343434] py-1 rounded-[8px]'>
            <img src={Logo} alt='Creative Dots' className='h-full w-full' />
          </div>
          <h2 className="text-[26px] font-montserrat font-bold leading-[30px] text-[#C61E46] text-center w-[100%] sm:w-[80%]">
              {blog?.Title}
          </h2>
          <div className='blog-media-wrap w-[100%]'>
            <img src={BannerBG} alt={blog?.Title} className='h-full w-full' />
          </div>
          <div>

          </div>
          <div dangerouslySetInnerHTML={{ __html: blog?.DescriptionText }}>
          </div>
        </div>

        <div className='w-[35%] flex flex-col gap-8'> 
          <h2 className="text-[26px] font-montserrat font-bold leading-[30px] text-[#C61E46] uppercase text-left">
            Recent Posts
          </h2>
          {
            BlogsData?.map((blog, ind) => {
              return(
                <div key={ind} className='flex rounded-[16px] bg-[#fff] shadow-lg'>
                  <div className='blog-media-wrap w-[35%]'>
                    <img src={blog?.ImgSrc} alt={blog?.Title} className='h-full w-full' style={{borderTopLeftRadius: '16px', borderBottomLeftRadius: '16px'}} />
                  </div>
                  <div className='blog-body-wrap w-[65%] p-4 flex flex-col gap-3 justify-between h-full'>
                    <h2 className='text-[16px] font-[500] font-montserrat leading-[24px] text-[#C61E46] uppercase truncate'> {blog?.Category} </h2>
                    <h3 
                      className='text-[18px] sm:text-[20px] font-[500] font-montserrat leading-[26px] text-[#343434]' 
                      style={{ overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}
                    > 
                      {blog?.Title} 
                    </h3>
                    <button 
                      onClick={()=> handleBlogView(blog?.Title)}
                      className='flex items-center gap-2 text-[18px] font-montserrat !font-[500] text-[#fff] bg-[#343434] btn-slide border-2 border-[#C61E46] px-6 py-2 rounded-[12px] gravity-transition w-max'> 
                      Read More 
                    </button>
                  </div>
                </div>
              )
            })
          }
        </div>
      </section>
    </>
  )
}

export default SingleBlogPage